import { useSelector } from 'react-redux';
import { selectReportSummaryReportSectionsIsOpen } from '../../selectors';

export const useSelectReportSectionsIsOpen = (): boolean => {
  const selectReportSectionsIsOpen = useSelector(selectReportSummaryReportSectionsIsOpen);
  return selectReportSectionsIsOpen;
};
